<template>
  <div class="blind-box-select">
    <img :src="selectBlindboxHeader" />
    <div class="blind-box-grid-container">
      <div v-for="i in cubes" :key="i" class="item" @click="selectSlot()">
        <img :src="`/static/img/blind-box/select/cube-${(i % 4) + 1}.svg`" height="170" width="170" />
      </div>
    </div>
    <footer>
      <img :src="selectBlindboxFooter" alt="Blind Box Footer" />
    </footer>
    <img class="back-arrow" :src="backArrow" @click="goBack" />
    <please-wait-popup :is-visible="showPleaseWaitPopup" @close="showPleaseWaitPopup = false">
      <div class="please-wait-popup-content">
        <img :src="pleaseWaitImg" />
        <h2>Please Wait...</h2>
        <p>Silakan coba lagi dalam 10 detik</p>
      </div>
    </please-wait-popup>

    <dispense-popup :is-visible="showDispensePopup" @close="onCloseDispensing" />
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
const SECOND = 1000;

export default {
  components: {
    PleaseWaitPopup: () => import('./ui/blind-box-popup.vue'),
    DispensePopup: () => import('./layout/dispense-popup.vue'),
  },
  data() {
    return {
      storeDetail: null,
      selectBlindboxHeader: '/static/img/blind-box/select/header-new.svg',
      selectBlindboxFooter: '/static/img/blind-box/select/footer-new.svg',
      backArrow: '/static/img/blind-box/global/back-arrow.svg',
      cubes: [1, 2, 3, 4, 7, 8, 6, 5, 10, 9, 12, 11, 16, 15, 13, 14],
      lastSelectedTime: null,
      showPleaseWaitPopup: false,
      showDispensePopup: false,
      pleaseWaitImg: '/static/img/blind-box/select/please-wait.svg',
      idleTimer: null,
      idleTimeout: 60 * SECOND, // 5 minutes
      durationBeforeHome: 10 * SECOND,
    };
  },
  computed: {
    voucherCode() {
      return this.$store.state.blindBoxStore.activeBlindBoxVoucher || '';
    },
  },
  mounted() {
    this.storeDetail = Cookies.get('store_detail');
    if (!this.storeDetail) {
      this.$router.replace('/');
    }
    if (this.voucherCode.length === 0) {
      this.$router.replace(`/blind-box`);
    }
    this.startIdleTimer();
    this.addIdleListeners();
  },
  beforeDestroy() {
    this.clearIdleTimer();
    this.removeIdleListeners();
  },
  methods: {
    onCloseDispensing() {
      this.showDispensePopup = false;
      this.clearIdleTimer();
      this.removeIdleListeners();
      const context = this;
      setTimeout(() => {
        context.$router.replace('/blind-box');
      }, 300);
    },
    resetIdleTimer() {
      this.clearIdleTimer();
      this.startIdleTimer();
    },
    startIdleTimer() {
      this.idleTimer = setTimeout(() => {
        this.$router.replace('/blind-box');
      }, this.idleTimeout);
    },
    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },
    addIdleListeners() {
      ['mousemove', 'keydown', 'click', 'touchstart'].forEach((event) =>
        window.addEventListener(event, this.resetIdleTimer)
      );
    },
    removeIdleListeners() {
      ['mousemove', 'keydown', 'click', 'touchstart'].forEach((event) =>
        window.removeEventListener(event, this.resetIdleTimer)
      );
    },
    goBack() {
      this.$router.replace('/blind-box/');
      this.clearIdleTimer();
      this.removeIdleListeners();
    },
    async saveLog(isDispensed, slot, product) {
      const payloadCreated = {
        screen: 'Blind Box',
        voucher_code: this.voucherCode,
        store: {
          id: this.storeDetail._id,
          name: this.storeDetail.name,
        },
        is_product_dispensed: isDispensed,
        tier: 'N/A',
        product: product ? product : { name: 'N/A', id: 'N/A' },
        slot: slot,
      };
      await axios.post(`${Config.MS_SOCIOLLA_PUBLIC_API_URL}/vending-machine/logs`, payloadCreated).then((res) => {
        console.log(res);
      });
    },
    handleDispense() {
      const storeDetail = JSON.parse(Cookies.get('store_detail'));
      const dispenseUrl = `${Config.MS_CATALOG_API_URL}/vending-machines/${storeDetail._id}/dispense`;
      const payload = {
        voucherCode: this.voucherCode,
        isBlindBox: true,
      };
      this.$axios
        .post(dispenseUrl, payload)
        .then((response) => {
          if (response.data.success) {
            this.showDispensePopup = true;
            const slot = response.data.data.slot;
            const product = response.data.data.product;
            if (slot) {
              const slotMachineUrl = `http://localhost:1945/trigger/${slot}`;
              this.$axios
                .get(slotMachineUrl)
                .then((res) => {
                  if (res.status && res.status != 200) {
                    console.log(res);
                  }
                  this.saveLog(true, slot, product);
                })
                .catch((err) => {
                  this.saveLog(false, slot, product);
                  console.error(err);
                })
                .finally(() => {
                  const context = this;
                  setTimeout(() => {
                    context.$router.push('/blind-box');
                  }, this.durationBeforeHome);
                });
            }
          } else if (response.errorCode === 'EXCEED_QUOTA') {
            this.$router.replace('/blind-box/out-of-stock');
          }
        })
        .catch((err) => {
          const errorCode = err?.response?.data?.errorCode || '';
          if (errorCode === 'EXCEED_QUOTA') {
            this.$router.replace('/blind-box/out-of-stock');
          }
        });
    },
    selectSlot() {
      const currentTime = new Date().getTime();
      const TEN_SECOND_TIMEOUT = 1000 * 10;
      if (this.lastSelectedTime && currentTime - this.lastSelectedTime < TEN_SECOND_TIMEOUT) {
        this.showPleaseWaitPopup = true;
        setTimeout(() => {
          this.showPleaseWaitPopup = false;
        }, 3000);
      } else {
        this.handleDispense();
      }

      this.lastSelectedTime = new Date().getTime();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './font/font.scss';
$bg-gradient: linear-gradient(180deg, #327fff 0%, #b0ceff 100%);
.blind-box-select {
  height: 100vh;
  width: 100%;
  padding-top: 50px;
  background: $bg-gradient;
}

.blind-box-grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  padding: 52px;
  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .item {
    box-shadow: 0px 4px 20px 0px #5c6fb7cc;
    border-radius: 22px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 45px 30px;
    cursor: pointer;
    transition: transform 0.2s;
    &:hover {
      transform: scale(1.05);
    }
  }
}
.back-arrow {
  position: fixed;
  top: 50px;
  left: 52px;
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.please-wait-popup-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 42px;
  width: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    height: 195px;
  }

  h2 {
    font-weight: 700;
    font-size: 40px;
    letter-spacing: 0.5px;
    text-align: center;
    color: #000000;
    margin: 48px 0 24px 0;
  }

  span {
    font-weight: 400;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    color: #716a68;
  }
}
</style>
